import React, { useEffect, useState } from 'react'
import { GetTotalSales } from '../api';
import moment from 'moment'

const ViewTable = ({id}) => {
  const [pending, setPending] = useState(false);
  const [total, setTotal] = useState(0);
  const [payments, setPayments] = useState([]);
  const [page, setPage] = useState(0);

  const fetchPayments = async () => {
    setPending(true);
    try{
      const res = await GetTotalSales(id, page, 50);
      setPayments(res.payments);
      setTotal(res.count)
    }catch(ex){
      console.log(ex);
    }finally{
      setPending(false)
    }
  }

  useEffect(()=>{
    fetchPayments()
  }, [])
  return (
    <div className=" rounded-lg overflow-hidden shadow-lg mt-5  main2">
    <div className="d-flex align-items-center ">
      <form className="navbar-form navbar-left d-flex  w-100 justify-content-between bg-light align-items-center px-3 py-5">
        <h1 className="pt-2 pl-2">Sale History</h1>

        {/* <div className=" d-flex align-items-center ">
      
          <button
            type="submit"
            className=" px-5 py-2 rounded-sm border-0 btn_color text-white ml-3"
          >
            Export CSV
          </button>
        </div> */}
      </form>
    </div>

    <table class="table  m-0 p-0 ">
      <thead className="bg-white text-center">
        <tr>
          <th>Service</th>
          <th>Name</th>
          <th>Email</th>
          <th>Price</th>
          <th>Date/Time</th>
      
        </tr>
      </thead>
      <tbody className="bg-light text-center">
      {/* <tr>
        <td>category</td>
        <td>title</td>
        <td>400$</td>
        <td>item</td>
        <td>12/9</td>

      </tr> */}
      {pending ? (
              <tr>
                <td colSpan={5}>
                  <div className="w-100 d-flex align-items-center justify-content-between mb-2">
                    <div
                      class="spinner-border text-danger mx-auto"
                      role="status"
                    ></div>
                  </div>
                </td>
              </tr>
            ) : (
              payments.map((item, index) => {
                return (
                  <tr key={index} className="">
                    <td>{ item.serviceId ? item.serviceId.title : item.serviceTitle ? item.serviceTitle : 'N/A' }</td>
                    {/* <td>{item.userId.profileImage}</td> */}
                    <td>{item.userId.firstName} {item.userId.lastName}</td>
                    <td className="td1"><a href={`mailto:${item.userId.email}`}>{item.userId.email}</a></td>
                    <td>${item.amount / 100}</td>
                    <td>{moment(item.createdAt).format('DD-MM-YYYY hh:mm A')}</td>
                  </tr>
                );
              })
            )}

      { !pending && payments.length == 0 && <tr><td align='center' colSpan={5}>No Sale Available</td></tr> }

      </tbody>
    </table>
  </div>
  )
}

export default ViewTable